import React from 'react';
import classnames from 'classnames';
import { formatDateMDY, getBackgroundImg, getPublicImagePath } from '@nutastic/nutastic-react-app';
import { ReactSVG } from 'react-svg';

const getHeaderClass = type => {
    switch ((type || 0).toString()) {
        case '1': return 'full-image';
        case '2': return 'square-image';
        case '3': return 'article-layout';
        default: return 'basic-layout';
    }
};

const getHeaderBackgroundColor = type => {
    switch ((type || 0).toString()) {
        case '1': return 'background-green';
        case '2': return 'background-yellow';
        case '3': return 'background-black';
        default: return 'background-gray';
    }
};

// eslint-disable-next-line react/prop-types
const PageHeader = ({ backgroundColorId, className, date, image, subtext, title, type }) => {
    const componentClass = 'page-header';
    const backgroundColorClass = getHeaderBackgroundColor(backgroundColorId);
    const classes = classnames(
        componentClass,
        className,
        backgroundColorClass,
        `${componentClass}--${getHeaderClass(type)}`
    );
    const headerImgStyle = type && image ? getBackgroundImg(image) : {};
    const useImage = ((type || 0).toString() === '1' || (type || 0).toString() === '2') && image !== '';
    const useBlogImage = (type || 0).toString() === '3' && image;

    return <section className={classes}>
        <ReactSVG src={getPublicImagePath('ripped-page.svg')} className={`${componentClass}__pageRip`} />
        { useImage && <div className={`overlay ${backgroundColorClass}`} /> }
        { useImage && <div className={`${componentClass}__img ${backgroundColorClass}`} style={headerImgStyle} /> }
        <div className={ `${componentClass}__container` }>
            { useBlogImage && <img src={image} alt={title} className={`${componentClass}__articleImage`} /> }
            <div className={`${componentClass}__content`}>
                <h1 className="isCursive">{ title }</h1>
                { subtext && <p>{ subtext }</p> }
                { date && <div className={`${componentClass}__date`}>{ formatDateMDY(date) }</div> }
            </div>
        </div>
    </section>;
};

export default PageHeader;
